// Bureau shows the payslip templates (self_bill, draft_self_bill) as
// payslips. The stored template keeps its self bill id and wording; only what
// is shown changes.
export const isBureauPayslipTemplate = (templateId?: string) =>
  templateId === 'self_bill' || templateId === 'draft_self_bill';

export const toBureauPayslipTemplateId = (templateId?: string) =>
  (templateId || '').replace(/self_bill/gi, 'payslips');

export const toBureauPayslipSubject = (subject?: string) =>
  (subject || '').replace(/Self Bill/gi, 'Payslips');

// Mirrors the backend's replaceSelfbillToPayslip, which the payslip email
// applies when it is sent: the editor then shows the wording the employee
// gets, and the password note still matches the one the backend strips.
const PAYSLIP_REPLACEMENTS: [string, string][] = [
  ['SelfBill', 'Payslip'],
  ['Self Bill', 'Payslip'],
  ['Selfbill', 'Payslip'],
  ['Self bill', 'Payslip'],
  ['Self-bill', 'Payslip'],
  ['selfBill', 'payslip'],
  ['self Bill', 'payslip'],
  ['selfbill', 'payslip'],
  ['self bill', 'payslip'],
  ['self-bill', 'payslip'],
];

export const toBureauPayslipText = (text?: string) =>
  PAYSLIP_REPLACEMENTS.reduce(
    (result, [from, to]) => result.split(from).join(to),
    text || '',
  );
